import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

const Box = styled.div`
  overflow: visible;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.itemBackground};
  border-radius: 34px;
  padding: 3px;
  cursor: pointer;
  transition: 0.2s cubic-bezier(0.17, 0.67, 0.83, 0.67);
                      min-width: 230px;
  &:hover {
    transform: translateY(-5%);
  }
`
const Group = styled.div`
display: flex;
flex-direction: column;
align-items: left;
width: -webkit-fill-available;
`
const Title = styled.h2`
  font-weight: 800;
  font-size: 14px;
  text-align: left;
  color: ${({ theme }) => theme.headerSubtitle};
  margin: 0 24px 0 24px;
`
const Date = styled.p`
  font-weight: 800;
  font-size: 12px;
  text-align: left;
  color: ${({ theme }) => theme.headerTitle};
  margin: 8px 24px 24px 24px;
`
const NewsImg = styled.img`
width: 100%;
height: 100%;
border-radius: 34px;
`
const StyledLink = styled(Link)`
  overflow: visible;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1;
  width: auto;
  height: auto;
  background-color: ${({ theme }) => theme.itemBackground};
  border-radius: 34px;
  margin: 0 0 16px 24px;
  cursor: pointer;
  transition: 0.2s cubic-bezier(0.17, 0.67, 0.83, 0.67);
  &:hover {
    transform: translateY(-5%);
  }
text-decoration: unset;
`

const News = (props) => {
  return (
    <StyledLink to={`${props.link}`}>
            <Box theme={props.theme}>
        <NewsImg src={props.image}></NewsImg>
        <Group>
                <Title>{props.title}</Title>
          <Date>{props.date}</Date>
        </Group>
      </Box>
    </StyledLink>
    )
}

export default News